<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="aprovacoes.content"
      :expanded.sync="expanded"
      class="elevation-1 mt-5 rounded-card card-shadow"
      :loading="loading"
      :server-items-length="aprovacoes.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhuma aprovação pendente"
      loading-text="Carregando aprovações..."
      :options="optionsList"
    >
      <template v-slot:item.id=" { item }">
        <div class="text-center">
          <px-span-tooltip bottom :text="item.id" tooltip="Aprovação Proxpect"/>
        </div>
      </template>
      <template v-slot:item.fornecedor.nome="{ item }">
        <px-span-tooltip top :text="fornecedor(item)" :tooltip="item.fornecedor.pessoa.nome"/>
      </template>
      <template v-slot:item.comprador="{ item }">
        <px-span-tooltip top :text="comprador(item)" :tooltip="item.comprador.pessoa.nome"/>
      </template>
      <template v-slot:item.solicitante="{ item }">
        <px-span-tooltip top :text="solicitante(item)" :tooltip="item.usuario.nome"/>
      </template>
      <template v-slot:item.createdIn="{ item }">
        {{ item.createdIn | date(true) }}
      </template>
      <template v-slot:item.situacao="{ item }">
        <px-situacao-aprovacao :situacao="item.situacao"/>
      </template>
      <template v-slot:item.total="{ item }">
        {{ item.valorMoedaConvertido.total | currency }}
        <px-moeda-chip v-if="isMoedaEstrangeiraFn(item.moeda)" :moeda="item.moeda"/>
        <div class="caption" v-if="isMoedaEstrangeiraFn(item.moeda)">
          {{ item.total | currency(simboloMoedaFn(item.moeda),
          2,
          configuracaoFormatacaoMoedaFn(item.moeda)) }}
        </div>
      </template>
      <template v-slot:item.options="{ item }">
        <v-btn icon @click="goToAprovacao(item)">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Vue from 'vue';
import { SituacaoCompra } from 'px-business-components';
import moedaMixin from '@/mixins/moeda-mixin';

export default {
  mixins: [moedaMixin],
  props: {
    aprovacoes: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      expanded: [],
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Código',
          value: 'id',
        },
        {
          text: 'Fornecedor',
          value: 'fornecedor.nome',
        },
        {
          text: 'Solicitante',
          value: 'solicitante',
          sortable: false,
        },
        {
          text: 'Empresa',
          value: 'comprador',
        },
        {
          text: 'Solicitado em',
          value: 'createdIn',
        },
        {
          text: 'Situação',
          value: 'situacao',
        },
        {
          text: 'Total',
          value: 'total',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    comprador() {
      return item => Vue.filter('truncate')(item.comprador.pessoa.nome, 20);
    },
    fornecedor() {
      return item => Vue.filter('truncate')(item.fornecedor.pessoa.nome, 35);
    },
    solicitante() {
      return item => Vue.filter('truncate')(item.usuario.nome, 20);
    },
    isFinalizada() {
      return item => SituacaoCompra.keys.APROVADA.key === item.situacao;
    },
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    goToAprovacao(item) {
      this.$router.push({
        name: 'main.aprovacao.detalhes',
        params: {
          id: item.id,
        },
      });
    },
  },
};
</script>
